// extracted by css-extract-rspack-plugin
export default {"group":"gva9bYQZVq4dzDp2"};